/// <amd-module name="Wit/WorkItems/Utilities/WorkItemUtilities" />
import { FieldValueMap, FieldValueType, IWorkItemTypeField } from "Wit/WorkItemTypes/Contracts";
import { IWorkItem } from "../WorkItemContracts";
import { isValueNullOrWhitespace } from "./FieldUtilities";

let temporaryWorkItemIdCounter = -1;
/**
 * Generates a new temporary workItemId
 * Note: Temporary workItemId is negative and this method returns a new id everytime in decrements of 1 starting from '-1'
 */
export function getNewTemporaryWorkItemId(): number {
    return temporaryWorkItemIdCounter--;
}

export function isWorkItemNew(workItemId: number): boolean {
    return workItemId < 0;
}

export function getFieldsWithValues(workItem: IWorkItem): FieldValueMap {
    const dirtyFieldsMap: FieldValueMap = {};
    for (const fieldRefName of Object.keys(workItem.fields)) {
        const workItemField = workItem.fields[fieldRefName];
        if (!isValueNullOrWhitespace(workItemField)) {
            dirtyFieldsMap[fieldRefName] = workItemField;
        }
    }

    return dirtyFieldsMap;
}

export function isWorkItemValid(workItem: IWorkItem, workItemTypeFieldsByRefName: { [refName: string]: IWorkItemTypeField } | undefined): boolean {
    if (!workItem || !workItem.fields || !workItemTypeFieldsByRefName) {
        return false;
    }
    return Object.keys(workItemTypeFieldsByRefName)
        .filter(workItemField => workItemTypeFieldsByRefName[workItemField].alwaysRequired === true)
        .every(fieldRefName => !isValueNullOrWhitespace(workItem.fields[fieldRefName]));
}

export function transformWorkItemFields(
    workItemFieldValues: FieldValueMap,
    workItemTypeFields: { [refName: string]: IWorkItemTypeField },
    initializeWithDefaultValues?: boolean
): { [key: string]: FieldValueType } {
    // Transform ref names for given field values to lowercase
    const transformedFieldValues: FieldValueMap = {};
    for (const fieldRefName of Object.keys(workItemFieldValues)) {
        transformedFieldValues[fieldRefName.toLocaleLowerCase()] = workItemFieldValues[fieldRefName];
    }
    const workItemFields: { [key: string]: FieldValueType } = {};

    for (const workItemTypeField in workItemTypeFields) {
        const fieldRefName = workItemTypeFields[workItemTypeField].referenceName.toLocaleLowerCase();
        let fieldValue = transformedFieldValues[fieldRefName];
        if (
            fieldValue === undefined &&
            initializeWithDefaultValues &&
            workItemTypeFields[workItemTypeField].alwaysRequired &&
            workItemTypeFields[workItemTypeField].defaultValue != null
        ) {
            fieldValue = workItemTypeFields[workItemTypeField].defaultValue;
        }
        workItemFields[fieldRefName] = fieldValue;
    }

    return workItemFields;
}
